'use client';

import { Inter } from "next/font/google";
import "./globals.css";
import { AppProvider } from "../context/appContext";
import { HelmetProvider } from "react-helmet-async";
import 'quill/dist/quill.snow.css'; // Import Quill's Snow theme styles

const inter = Inter({ subsets: ["latin"] });

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <html lang="en">
      <head>
        <title>Data Pulse Technologies</title>
        <meta
          name="description"
          content="Leading provider of web development, data analytics, and software solutions."
        />
        <meta name="robots" content="index, follow" />
        <meta
          name="google-site-verification"
          content="stV9TtkrqQtGxWJRxcQte5Rl7NYySnjCKfkyHstv-xg"
        />
        {/* Add more metadata as needed */}
      </head>
      <body className={inter.className}>
        <HelmetProvider>
          <AppProvider>
            {children}
          </AppProvider>
        </HelmetProvider>
      </body>
    </html>
  );
}
